import React, { lazy, Suspense } from "react";

const LazyLoad = (
  importFunc,
  { fallback = null } = { fallback: "" }
) => {
  const LazyComponent = lazy(importFunc);
  return (props) => (
    <Suspense fallback={fallback}>
      <LazyComponent {...props} />
    </Suspense>
  );
};

export default LazyLoad;
